import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SnackbarType } from '../../_enums/snackbar-type.enum';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-inline-snackbar',
  imports: [CommonModule, MatIcon, MatIconButton],
  templateUrl: './inline-snackbar.html',
  styleUrl: './inline-snackbar.scss',
})
export class InlineSnackbar {
  @Input() public type!: SnackbarType;
  @Input() public message!: string;
  @Input() public showCloseButton = true;

  @Output() public dismiss = new EventEmitter();

  public getIcon(type: SnackbarType): string {
    switch (type) {
      case SnackbarType.SUCCESS:
        return 'check_circle';
      case SnackbarType.INFO:
        return 'info';
      case SnackbarType.ERROR:
        return 'warning';
      case SnackbarType.WARNING:
        return 'error';
      default:
        return '';
    }
  }
}
